export const TOGGLE_MODAL = 'TOGGLE_MODAL';
export const TOGGLE_SELECTED_SECRET = 'TOGGLE_SELECTED_SECRET';
